import { Component, OnInit, Input } from '@angular/core';
import { IFilterDateComponent } from '../filters.enum';

@Component({
  selector: 'lib-date-simple-range',
  templateUrl: './date-simple-range.component.html',
  styleUrls: ['./date-simple-range.component.scss']
})
export class DateSimpleRangeComponent implements OnInit {

  /**
   * An input variable for hide filters if required
   *
   * @type {boolean}
   * @memberof DateSimpleRangeComponent
   */
  @Input() hide: boolean = false;
  @Input() option_from: IFilterDateComponent;
  @Input() option_to: IFilterDateComponent;
  constructor() {

  }

  ngOnInit() {
  }

}
